export default __webpack_public_path__ + "static/_AD_9060_rgb_comp_final-9928c8ce5fae0b8d876b8bdb5735b154.jpg";